<div class="relative inline-block">
  <div
    class="py-1 px-2 border-round-xl flex align-items-center {{ statusBackgroundColour }}
      {{ statusTextColour }} {{ statusBackgroundHover }}"
    [class.cursor-pointer]="
      riskStatus == TaskRiskStatus.Open || riskStatus == TaskRiskStatus.InReview
    "
    (click)="toggleDropdown()"
  >
    {{ statusText }}
    <i
      *ngIf="riskStatus == TaskRiskStatus.Open || riskStatus == TaskRiskStatus.InReview"
      class="fa fa-chevron-down ml-1"
    ></i>
  </div>

  <span class="text-gray-700 absolute right-0 w-max mt-1">{{ reviewDateText }}</span>

  <div
    class="absolute right-0 mt-1 border-1 p-1 shadow-2 bg-white z-10 w-max border-round-lg border-gray-100 cursor-pointer hover:bg-gray-50"
    (click)="updateReviewStatus()"
    *ngIf="showDropdown"
  >
    {{ dropdownText }}
  </div>
</div>
